import { Flex, cssVar, styled, css, IconButton } from '@cad-arc';
import { colors } from '../../colors/colors';

const buttonStyle = css`
    box-shadow: ${cssVar('arc.shadows.lg')};
    color: ${colors.mapButtonForeground};
    background-color: ${colors.mapButtonBackground};
    border: 1px solid ${cssVar('arc.colors.brand.default')};

    &.active {
        background-color: ${cssVar('arc.colors.brand.hover')};
    }

    &:focus {
        z-index:1;
    }

    &.is-tracking {
        background-color: ${colors.mapButtonTrackingBackground};
        border: 1px solid ${colors.mapButtonTrackingBorder};
    }

    &:not(.is-tracking):hover {
        background-color: ${cssVar('arc.colors.brand.hover')};
    }
`;

export const IconButtonControl = styled(IconButton)`
    ${buttonStyle}
`;

export const CommandIconButton = styled('button')`
    ${buttonStyle};
    border-radius: ${cssVar('arc.radii.md')};
    height: ${cssVar('arc.sizes.control.md')};
    width: auto;
    padding: 5px;

    &[data-state='open'] {
        background-color: ${cssVar('arc.colors.brand.hover')};
    }
`;

export const ShortcutCommand = styled(Flex)`
    border-radius: ${cssVar('arc.radii.md')};
    background-color: ${cssVar('arc.colors.control.border.default')};
    padding: 5px;
    width: 24px;
    height: 24px;
`;
